import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { useSelector } from "react-redux";

export default function Footer() {
  const hasSubscription = useSelector((state) => state.user.hasSubscription);

  return (
    <>
      <section className="bg-black">
        <div className=" h-14 footer-bg"></div>
        <div className="max-w-screen-xl px-4 py-20 mx-auto space-y-8 overflow-hidden sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center">
            <img alt="Trackit" src="/footer-logo.svg" className="h-16"></img>
          </div>

          <nav className="flex flex-wrap justify-center -mx-5 -my-2">
            <div className="px-5 py-2">
              <Link
                to={"/"}
                className="text-base leading-6 text-gray-400 hover:text-gray-100 uppercase"
              >
                Home
              </Link>
            </div>
            <div className="px-5 py-2">
              <Link
                to={"/events"}
                className="text-base leading-6 text-gray-400 hover:text-gray-100 uppercase"
              >
                Events
              </Link>
            </div>

            {hasSubscription && (
              <div className="px-5 py-2">
                <Link
                  to={"#"}
                  className="text-base leading-6 text-gray-400 hover:text-gray-100 uppercase"
                >
                  Leaderboard
                </Link>
              </div>
            )}
            <div className="px-5 py-2">
              <Link
                to={"/register/coach"}
                className="text-base leading-6 text-gray-400 hover:text-gray-100 uppercase"
              >
                University Registration
              </Link>
            </div>
            <div className="px-5 py-2">
              <Link
                to={"/sign-in"}
                className="text-base leading-6 text-gray-400 hover:text-gray-100 uppercase"
              >
                Sign In
              </Link>
            </div>
            <div className="px-5 py-2">
              <Link
                to={"/Contact"}
                className="text-base leading-6 text-gray-400 hover:text-gray-100 uppercase"
              >
                Contact Us
              </Link>
            </div>
          </nav>
          <div className="flex justify-center mt-8 space-x-6">
            <Link
              to={
                "https://www.facebook.com/people/Track-Itt-Verified/61558262340147/"
              }
              target="_blank"
              className="text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">Facebook</span>
              <FontAwesomeIcon icon={faFacebook} size="xl" />
            </Link>

            <Link
              to={"https://www.instagram.com/trackit_verified/"}
              target="_blank"
              className="text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">Instagram</span>
              <FontAwesomeIcon icon={faInstagram} size="xl" />
            </Link>
            <Link
              to={"https://x.com/trackitsports"}
              target="_blank"
              className="text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">Twitter</span>
              <FontAwesomeIcon icon={faXTwitter} size="xl" />
            </Link>
          </div>
          <p className="mt-8 text-base leading-6 text-center text-gray-400">
            Copyright © Trackit Verified 2026. All Rights Reserved
          </p>
        </div>
      </section>
    </>
  );
}
